/* eslint-disable */

import React, { useMemo, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import {
  CardContent,
  IconButton,
  Box,
  Menu,
  MenuItem,
} from '@mui/material';

import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as KebabMenu } from '../../assets/images/kebab.svg';
import { ReactComponent as ArrowForwardIcon } from '../../assets/images/view-arrow.svg';
import { ReactComponent as MccLogo } from '../../assets/images/mcc-icon.svg';
import { ReactComponent as DisbursementDownload } from '../../assets/images/disbursementDownload.svg';

import nameCard from './nameCard.module.css';

import { leadValue } from '../../state/slice/leadSlice';
import { setMcclistValue } from '../../state/slice/mccListSlice';
import { loanValue } from '../../state/slice/loanListPayloadSlice';

import Path from '../../constants/path';
import Strings from '../../constants/stringConstant';

import { getInitial, getUserData, hasEditValue } from '../../utils/appUtils';

import { lmsBrNetApiCall } from '../../api/request/masterFetchApi/masterFetchApi';
import makeApiCall from '../../api/makeApiCall';

import ModalwithButton from '../Modal/modalwithButton';
import { partnerCaseWorkflowTriggerApi, processPoolCreationQueueApi } from '../../api/request/disbursementApi/disbursementApi';
import { toast } from 'react-toastify';

const NameCard = ({ cardData, setRejectModal, dashboardType, fetchData }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState(null);
  const [breRejectedModal, setBreRejectedModal] = useState(false);
  const [breMessage, setBreMessage] = useState('');

  const { roleBased } = useSelector(state => state.rbacValue);

  const { productCategories } = useSelector(
    state => state.productFilterSlice,
  );

  const DASHBOARD_CONFIG = useMemo(
    () => ({
      Lead: {
        type: 'lead',
        path: Path.lead,
        roleKey: 'lead',
      },

      Mcc: {
        type: 'mcc',
        path: Path.mcc,
        roleKey: 'mcc',
      },

      QDE: {
        type: 'loan',
        path: Path.loan_applicant,
        roleKey: 'qde',
      },

      DDE: {
        type: 'loan',
        path: Path.loan_dde_applicant,
        roleKey: 'dde',
      },

      'Field Investigation': {
        type: 'loan',
        path: Path.loan_fi_applicant,
        roleKey: 'field_investigation',
      },

      'Review & FI': {
        type: 'loan',
        path: Path.loan_review_fi_applicant,
        roleKey: 'review_and_fi',
      },

      Review: {
        type: 'loan',
        path: Path.loan_dde_applicant,
        roleKey: 'review',
      },

      'Personal Discussion': {
        type: 'loan',
        path: Path.loan_personal_dis_applicant,
        roleKey: 'personal_discussion',
      },

      on_hold: {
        type: 'loan',
        path: Path.loan_onhold_applicant,
      },

      Rejected: {
        type: 'loan',
        path: Path.loan_rejected_application,
      },

      [Strings.loan_applications.dashboard_type_eligiblity]: {
        type: 'loan',
        path: Path.loan_eligibility_applicant,
        roleKey: 'eligibility_check_and_cam',
      },

      [Strings.loan_applications.dashboard_type_con]: {
        type: 'loan',
        path: Path.loan_conversation_applicant,
      },

      [Strings.loan_applications.dashboard_type_order_con]: {
        type: 'loan',
        path: Path.loan_order_con_applicant,
        roleKey: 'order_confirmation',
      },

      [Strings.loan_applications.dashboard_type_approval_flow]: {
        type: 'loan',
        path: Path.loan_approval_flow_applicant,
        roleKey: 'approval_flow',
      },

      [Strings.loan_applications.dashboard_type_loan_booking]: {
        type: 'loan',
        path: Path.loan_loan_booking_applicant,
        roleKey: 'loan_booking',
      },

      [Strings.loan_applications.dashboard_type_doc_esign]: {
        type: 'loan',
        path: Path.loan_document_esign_applicant,
        roleKey: 'document_execution',
      },

      [Strings.loan_applications.dashboard_type_doc_verify]: {
        type: 'loan',
        path: Path.loan_document_verify_applicant,
        roleKey: 'document_verification',
      },

      [Strings.loan_applications.dashboard_type_disbursement]: {
        type: 'loan',
        path: Path.loan_disbursement_applicant,
        roleKey: 'disbursement',
      },

      [Strings.loan_applications.dashboard_type_fcu]: {
        type: 'loan',
        path: Path.loan_fcu_applicant,
        roleKey: 'fraud_control_unit',
      },

      [Strings.loan_applications.dashboard_type_legal_review]: {
        type: 'loan',
        path: Path.loan_lr_applicant,
        roleKey: 'legal_review',
      },

      [Strings.loan_applications.dashboard_type_property_valuer]: {
        type: 'loan',
        path: Path.loan_pr_applicant,
        roleKey: 'property_valuer',
      },

      [Strings.loan_applications.dashboard_type_sr]: {
        type: 'loan',
        path: Path.loan_sr_applicant,
        roleKey: 'secondary_review',
      },

      [Strings.loan_applications.dashboard_type_sanction]: {
        type: 'loan',
        path: Path.loan_sanction_applicant,
        roleKey: 'sanction',
      },

      [Strings.loan_applications.dashboard_type_deviation_appro]: {
        type: 'loan',
        path: Path.loan_deviation_approval_appli,
        roleKey: 'deviation_approval',
      },

      [Strings.loan_applications.dash_type_tranche_dis]: {
        type: 'loan',
        path: Path.loan_tranche_dis_appli,
        roleKey: 'tranch_disbursement',
      },

      [Strings.loan_applications.dash_type_tranche_ver]: {
        type: 'loan',
        path: Path.loan_tranche_ver_appli,
        roleKey: 'tranch_verification',
      },

      [Strings.loan_applications.dash_type_tranche_exe]: {
        type: 'loan',
        path: Path.loan_tranche_exe_appli,
        roleKey: 'tranch_execution',
      },

      [Strings.manageReassignement.manageReassignementHeader]: {
        type: 'loan',
        path: Path.manage_reassign_detail,
      },
      [Strings.loan_applications.dashboard_type_co_lending]: {
        type: 'loan',
        path: Path.loan_co_lending_applicant,
        roleKey: 'co_lending',
      },

      [Strings.loan_applications.dashboard_type_partner_app]: {
        type: 'loan',
        path: Path.loan_partner_approval_appli,
        roleKey: 'partner_approval',
      },

      [Strings.loan_applications.dash_type_pending_partner_upd]: {
        type: 'loan',
        path: Path.loan_pending_partner_appli,
        roleKey: 'pending_partner_update',
      },

    }),
    [],
  );
  const currentDashboard = DASHBOARD_CONFIG[dashboardType] || {};

  const isLead = currentDashboard.type === 'lead';
  const isMcc = currentDashboard.type === 'mcc';

  const canEdit = useMemo(() => {
    if (!currentDashboard.roleKey) return true;

    return hasEditValue(
      roleBased?.[currentDashboard.roleKey],
    );
  }, [currentDashboard, roleBased]);

  const isReady = cardData?.status === 'READY';

  const isIncompleteStatus = [
    'Incomplete',
    'Follow_up',
    'INCOMPLETE',
  ].includes(cardData?.status);

  const showDownloadedApp =
    (dashboardType === Strings.loan_applications.dashboard_type_disbursement ||
      dashboardType === Strings.loan_applications.app_type_tranche_dis) &&
    cardData?.status === 'Pending for Fund Transfer' &&
    cardData?.isCsvDownloaded;

  const isParallelWorkflow = [Strings.loan_applications.dashboard_type_fcu, Strings.loan_applications.dashboard_type_legal_review, Strings.loan_applications.dashboard_type_property_valuer].includes(dashboardType);

  const showKebabMenu = useMemo(() => {
    if (isLead) {
      return isIncompleteStatus && canEdit;
    }

    if (dashboardType === 'Mcc') {
      return canEdit;
    }

    if (
      (dashboardType === Strings.loan_applications.dashboard_type_disbursement ||
        dashboardType === Strings.loan_applications.app_type_tranche_dis)
    ) {
      return (
        (['READY', 'INCOMPLETE'].includes(cardData?.status) || cardData?.manualTrigger) &&
        canEdit
      );
    }
    if (dashboardType ===
      Strings.loan_applications.dashBoard_type_rejected) {
      return false;
    }
    if (isParallelWorkflow && isReady) {
      return false;
    }

    return canEdit;
  }, [
    isLead,
    isIncompleteStatus,
    canEdit,
    dashboardType,
    cardData,
  ]);

  const dispatchData = useCallback(
    type => {
      if (isLead) {
        dispatch(
          leadValue({
            lead: cardData,
            type,
          }),
        );

        return;
      }

      if (isMcc) {
        dispatch(
          setMcclistValue({
            mcc: cardData,
            type,
          }),
        );

        return;
      }

      dispatch(
        loanValue({
          loan: cardData,
          type,
        }),
      );
    },
    [dispatch, cardData, isLead, isMcc],
  );

  const callLmsBrNetApi = async () => {
    try {
      const response = await makeApiCall(
        lmsBrNetApiCall({
          loanApplicationId: cardData?.loanApplicationId,
        }),
      );

      if (response?.data?.status === Strings.success) {
        navigate(Path.loan_disbursement_applicant);
      } else {
        const errorCode = response?.data?.error?.errorCode;

        if (['SAMASTA150', 'SAMASTA151'].includes(errorCode)) {
          setBreMessage(
            response?.data?.error?.errorMessage,
          );

          setBreRejectedModal(true);

          setTimeout(() => {
            setBreRejectedModal(false);
            navigate('/loan-application');
          }, 2000);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const navigateToPage = useCallback(
    async type => {
      if (cardData?.status === 'Pending Pool Creation') {
        handlePoolCreation();
        return;
      }

      dispatchData(type);
      if (
        (dashboardType === Strings.loan_applications.dashboard_type_disbursement ||
          dashboardType === Strings.loan_applications.app_type_tranche_dis) &&
        isReady &&
        productCategories === 'Surabhi-DCL-Unsecured'
      ) {
        await callLmsBrNetApi();
        return;
      }
      if (currentDashboard?.path) {
        navigate(currentDashboard.path);
      }
      console.log(type, nameCard, 'nameCard');
    },
    [
      dispatchData,
      dashboardType,
      isReady,
      productCategories,
      currentDashboard,
      navigate,
    ],
  );

  const handleMenuOpen = event => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = event => {
    event.stopPropagation();

    navigateToPage(Strings.creation_edit_type);

    handleMenuClose();
  };

  const handleManualTrigger = async (event) => {
    event.stopPropagation();
    try {
      let response = await makeApiCall(
        partnerCaseWorkflowTriggerApi({
          loanApplicationId: cardData?.loanApplicationId,
          empCode: getUserData()?.userId,
          flow: 'manual',
        }),
      );
      if (response?.data?.status === Strings.success) {
        fetchData();
        handleMenuClose();
      } else {
        toast.error(response?.data?.error?.errorMessage);
      }

    } catch (error) {
      toast.error(Strings.apiError, {
        position: 'top-right',
      });
    }
  };

  const handlePoolCreation = async () => {
    try {
      let response = await makeApiCall(
        processPoolCreationQueueApi({
          loanApplicationIds: [cardData?.loanApplicationId],
          scheduleCallFlow: 'manual',
        }),
      );
      if (response?.data?.status === Strings.success) {
        fetchData();
      } else {
        toast.error(response?.data?.error?.errorMessage);
      }

    } catch (error) {
      toast.error(Strings.apiError, {
        position: 'top-right',
      });
    }
  };

  const handleReject = event => {
    event.stopPropagation();
    dispatchData(Strings.creation_view_type);
    setRejectModal(true);

    handleMenuClose();
  };

  const handleCardClick = () => {
    if (!canEdit && isReady) return;

    let type = Strings.creation_view_type;

    if (isReady && canEdit) {
      type = Strings.creation_add_type;
    }

    if (dashboardType === 'Rejected') {
      type = Strings.creation_reject_type;
    }

    if (
      dashboardType ===
      Strings.manageReassignement.manageReassignementHeader
    ) {
      type = Strings.creation_edit_type;
    }

    navigateToPage(type);
  };

  const renderMenuItems = () => {
    if (
      isIncompleteStatus ||
      dashboardType ===
      Strings.loan_applications.dashboard_type_onhold ||
      dashboardType ===
      Strings.loan_applications.dashboard_type_order_con
    ) {
      return (
        <>
          <MenuItem onClick={handleEdit}>
            <span className="text-medium-14px">
              Edit
            </span>
          </MenuItem>

          {!isParallelWorkflow && <MenuItem onClick={handleReject}>
            <span className="text-medium-14px">
              Reject
            </span>
          </MenuItem>}
        </>
      );
    }

    if (
      dashboardType === 'Mcc' ||
      dashboardType ===
      Strings.loan_applications.dashboard_type_con
    ) {
      return (
        <MenuItem onClick={handleEdit}>
          <span className="text-medium-14px">
            Edit
          </span>
        </MenuItem>
      );
    }

    if (cardData?.manualTrigger) {
      return (
        <MenuItem onClick={handleManualTrigger}>
          <span className="text-medium-14px">
            Retry
          </span>
        </MenuItem>
      );
    }

    if (isReady) {
      return (
        <MenuItem onClick={handleReject}>
          <span className="text-medium-14px">
            Reject
          </span>
        </MenuItem>
      );
    }

    return null;
  };

  const displayData = useMemo(() => {
    if (isLead) {
      return {
        initial: getInitial(
          cardData?.contactDetails?.firstName,
        ),
        name: cardData?.contactDetails?.fullName,
        subText:
          cardData?.contactDetails?.mobileNumber,
      };
    }

    if (isMcc) {
      return {
        initial: <MccLogo />,
        name: cardData?.mccName,
        subText: cardData?.mccId,
      };
    }

    return {
      initial: getInitial(
        cardData?.applicantName || cardData?.fullName,
      ),
      name:
        cardData?.applicantName ||
        cardData?.fullName ||
        'N/A',
      subText: (
        <>
          {cardData?.mobileNumber}
          <span className={nameCard.dot}></span>

          {dashboardType ===
            Strings.manageReassignement
              .manageReassignementHeader
            ? cardData?.role
            : cardData?.loanApplicationId}
        </>
      ),
    };
  }, [
    cardData,
    isLead,
    isMcc,
    dashboardType,
  ]);

  const handleKeyDown = event => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleCardClick();
    }
  };


  return (
    <Box
      tabIndex={0}
      onClick={handleCardClick}
      onKeyDown={handleKeyDown}
      className={nameCard.nameCard_container}>
      <Box className={nameCard.nameCard_initial}>
        <Box
          className={`text-medium-24px ${nameCard.nameCard_initial_circle}`}
          sx={{
            paddingTop: isMcc ? '5px' : '0px',
          }}>
          {displayData.initial}
        </Box>
      </Box>

      <CardContent
        className={nameCard.nameCard_card_content}>
        <Box
          className={`text-bold-16px ${nameCard.nameCard_name}`}>
          {displayData.name}
        </Box>

        <Box
          className={`text-regular-12px ${nameCard.nameCard_number}`}>
          {displayData.subText}
        </Box>
      </CardContent>

      {!(!canEdit && isReady) &&
        (showKebabMenu ? (
          <IconButton
            aria-label="settings"
            onClick={handleMenuOpen}>
            <KebabMenu />
          </IconButton>
        ) : showDownloadedApp ? (
          <IconButton aria-label="download">
            <DisbursementDownload />
          </IconButton>
        ) : (
          <IconButton
            aria-label="view"
            onClick={handleCardClick}>
            <ArrowForwardIcon />
          </IconButton>
        ))}

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        onClick={event => event.stopPropagation()}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          style: {
            width: '146px',
            boxShadow: 'none',
            border: '1px solid #ccc',
            borderRadius: '8px',
            padding: 0,
          },
        }}>
        {renderMenuItems()}
      </Menu>

      <ModalwithButton
        open={breRejectedModal}
        message="Application has been Rejected"
        subMessage={breMessage}
        rejectedLottie
      />
    </Box>
  );
};

NameCard.propTypes = {
  cardData: PropTypes.object,
  setRejectModal: PropTypes.func,
  dashboardType: PropTypes.string,
  fetchData: PropTypes.func,

};

export default React.memo(NameCard);
